module.exports = __webpack_public_path__ + "static/media/mvc.87a55afe.png";